var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import axios from 'axios';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import { useRoute } from 'ziggy-js';
import JetButton from '@/Jetstream/Button';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';
import { Ziggy } from "@/ziggy";
export default function JetConfirmsPassword(_a) {
    var _b = _a.title, title = _b === void 0 ? 'Confirm Password' : _b, _c = _a.content, content = _c === void 0 ? 'For your security, please confirm your password to continue.' : _c, _d = _a.button, button = _d === void 0 ? 'Confirm' : _d, onConfirm = _a.onConfirm, children = _a.children;
    var route = useRoute(Ziggy);
    var _e = useState(false), confirmingPassword = _e[0], setConfirmingPassword = _e[1];
    var _f = useState({
        password: '',
        error: '',
        processing: false,
    }), form = _f[0], setForm = _f[1];
    var passwordRef = useRef(null);
    function startConfirmingPassword() {
        axios.get(route('password.confirmation')).then(function (response) {
            if (response.data.confirmed) {
                onConfirm();
            }
            else {
                setConfirmingPassword(true);
                setTimeout(function () { var _a; return (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 250);
            }
        });
    }
    function confirmPassword() {
        setForm(__assign(__assign({}, form), { processing: true }));
        axios
            .post(route('password.confirm'), {
            password: form.password,
        })
            .then(function () {
            closeModal();
            setTimeout(function () { return onConfirm(); }, 250);
        })
            .catch(function (error) {
            var _a;
            setForm(__assign(__assign({}, form), { processing: false, error: error.response.data.errors.password[0] }));
            (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
    }
    function closeModal() {
        setConfirmingPassword(false);
        setForm({ processing: false, password: '', error: '' });
    }
    return (_jsxs("span", { children: [_jsx("span", __assign({ onClick: startConfirmingPassword }, { children: children })), _jsxs(JetDialogModal, __assign({ isOpen: confirmingPassword, onClose: closeModal }, { children: [_jsxs(JetDialogModal.Content, __assign({ title: title }, { children: [content, _jsxs("div", __assign({ className: "mt-4" }, { children: [_jsx(JetInput, { type: "password", className: "mt-1 block w-3/4", placeholder: "Password", value: form.password, onChange: function (e) {
                                            return setForm(__assign(__assign({}, form), { password: e.currentTarget.value }));
                                        } }), _jsx(JetInputError, { message: form.error, className: "mt-2" })] }))] })), _jsxs(JetDialogModal.Footer, { children: [_jsx(JetSecondaryButton, __assign({ onClick: closeModal }, { children: "Cancel" })), _jsx(JetButton, __assign({ className: classNames('ml-2', { 'opacity-25': form.processing }), onClick: confirmPassword, disabled: form.processing }, { children: button }))] })] }))] }));
}
